import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionNetworkConnected } from "../network/actionNetwork";
import { IdNetwork } from "../network/IdNetwork";
import { TypeActionReconnectAfterLogin } from "./actionReconnectAfterLogin";
export var epicReconnectAfterLogin = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionReconnectAfterLogin.ReconnectedAfterLogin), switchMap(function () {
        deps.netEnableConnections();
        return from([
            actionModalClose(IdModal.DisconnectedByLogin),
            actionNetworkConnected(IdNetwork.Core),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/reconnect-after-login/epicReconnectAfterLogin.ts
// module id = 2125
// module chunks = 3